<template>
  <app-header />
  <main class="relative tomu-main-content">
    <router-view />
  </main>
  <app-footer />
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";

export default {
  components: { AppFooter, AppHeader },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  @apply font-tomu;
  @apply text-lg;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.tomu-main-content {
  flex: 1;
}
</style>
